module.exports = __webpack_public_path__ + "images/emoji/large_blue_diamond.9222603c0f91ebf5f91d.png";